<div
  [id]="'tab-' + tab.name"
  [class]="'tab-container ' + divClasses()"
  (mouseover)="onTabHover()"
  (mouseout)="onTabHover()"
  (click)="onTabClick()"
>
  <svg-icon
    [svgClass]="'svgClass  h-[24px] w-[24px]' + svgClasses()"
    [src]="'assets/rush/svg/' + tab.icon + '.svg'"
  >
  </svg-icon>
  {{ tab.name }}
</div>
